import {ChangeDetectionStrategy, Component, ElementRef, HostBinding, input, output, ViewChild} from '@angular/core'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {FormControl, ReactiveFormsModule} from '@angular/forms'
import {I18nService} from '../i18n/i18n.service'
import {faXmark} from '@fortawesome/pro-solid-svg-icons/faXmark'
import {faSearch} from '@fortawesome/pro-solid-svg-icons/faSearch'
import {AsyncPipe} from '@angular/common'
import {SpinnerComponent} from '../spinner/spinner.component'
import {of} from 'rxjs'

@Component({
  selector: 'cft-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FontAwesomeModule, ReactiveFormsModule, AsyncPipe, SpinnerComponent],
})
export class SearchbarComponent {
  formControlInput = input.required<FormControl>()
  loading = input<boolean | null>(false)
  suggestions = input<string>()
  placeholder = input<string>()

  focused = output<FocusEvent>()
  cleared = output<void>()

  protected readonly searchIcon = faSearch
  protected readonly closeIcon = faXmark
  protected showSuggestions = false

  @HostBinding('class.active')
  protected active = false

  @ViewChild('searchInput') private searchInput!: ElementRef<HTMLDivElement>

  constructor(protected i18n: I18nService) {}

  public focus(options?: FocusOptions): void {
    this.searchInput?.nativeElement.focus(options)
  }

  protected onFocus(event: FocusEvent): void {
    this.active = true
    if (this.suggestions()) {
      this.showSuggestions = true
    }
    this.focused.emit(event)
  }

  protected onBlur(): void {
    this.active = false
    if (this.suggestions()) {
      this.showSuggestions = false
    }
  }

  protected clearInput(): void {
    this.formControlInput().setValue(undefined)
    this.cleared.emit()
  }

  protected hasValue(): boolean {
    return !!this.formControlInput().value
  }

  protected get searchPlaceholder$() {
    if (this.showSuggestions) {
      return this.suggestions() ? of(this.suggestions()) : this.i18n.translate$('searchbar.suggestions')
    } else {
      return this.placeholder() ? of(this.placeholder()) : this.i18n.translate$('searchbar.placeholder')
    }
  }
}
